export type PropsType = {
  onClick: (value: string | null) => void,
  selectedValue: string | null,
  buttons: { label: string, value: string | null }[]
  className?: string
  itemClassName?: string
}

function TabbedButtons(props: PropsType) {
  const { onClick, selectedValue, buttons, className = "", itemClassName = "" } = props;
  return (
    <div className={`flex flex-row justify-start items-center w-full border-b border-gray-400 ${className}`}>
      {buttons.map((btn, idx) => (
        <button
          type="button"
          key={`btn-${btn.value || "null"}-${idx}`}
          onClick={() => onClick(btn.value)}
          className={`min-w-32 md:min-w-48 h-10 md:h-12 border-b-2 px-2 ${itemClassName} ${selectedValue === btn.value ? "border-b-black" : "border-b-transparent"}`}
        >
          <span className="text-sm md:text-base whitespace-nowrap">
            {btn.label}
          </span>
        </button>
      ))}

    </div>
  );
}


export default TabbedButtons;
